export default "__VITE_ASSET__BkB0GNSt__"